import React, { createRef, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Form } from "formik";
import Button from "../common/Button";
import { langComponent } from "../../constants";
import AppContext from "../../AppContext";

import { ReactComponent as CertificateSvg } from "../../assets/icons/certificate.svg";
import { ReactComponent as ArrowLeftSvg } from "../../assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRightDisabledSvg } from "../../assets/icons/arrow-right-disabled.svg";
import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right.svg";
import OnboardContext from "./context";
import FileUploader from "../common/FileUploader";

const DBD = (props) => {
  const { goBack, goForward, information, addInformation } =
    useContext(OnboardContext);
  const [file, setFile] = useState(information.dbd || undefined);
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.onboard);
  const TranslationCommon = getLang(langComponent.common);

  const handleSkip = () => {
    addInformation({ dbd: undefined });
    goForward();
  };

  useEffect(() => {
    return () => {};
  }, []);

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      setFile(files[0]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!file) {
      return;
    }

    addInformation({ dbd: file });
    goForward();
  };

  return (
    <form className="onboard__form onboard-dbd" onSubmit={handleSubmit}>
      <CertificateSvg />
      <h4>Have DBD on hand?, Upload it now</h4>
      <FileUploader
        label={!file ? Translation("Upload DBD") : Translation("Change DBD")}
        onChange={handleFileChange}
      />
      <div className="onboard-dbd__file">
        {file && `${file.name} - ${file.type}`}
      </div>
      <div className="onboard__form-cta">
        <Button
          label={TranslationCommon("Return")}
          leadingIcon={<ArrowLeftSvg />}
          onClick={goBack}
          variant="secondary"
        />
        <div className="onboard__form-cta__divider" />
        <Button
          label={TranslationCommon("Skip")}
          variant="tertiary"
          onClick={handleSkip}
        />
        <Button
          type="submit"
          label={TranslationCommon("Continue")}
          disabled={!file}
          trailingIcon={file ? <ArrowRightSvg /> : <ArrowRightDisabledSvg />}
        />
      </div>
    </form>
  );
};

DBD.propTypes = {};

export default DBD;
